module.exports = __webpack_public_path__ + "static/img/OM13.2e0f1168.png";